@if (qualification) {
  <div class="slide-out">
    @if (qualification.saveQualification.response === 'No') {
      <p>
        drawer works! {{ qualification.saveQualification.response }}
      </p>
    }
  </div>
}
